<div class="order-list">
  <table mat-table [dataSource]="orders" class="mat-elevation-z8" width="100%">
    <ng-container matColumnDef="select" *ngIf="!hideCheckboxes">
      <th mat-header-cell *matHeaderCellDef>
        <mat-checkbox
          (change)="toggleSelectAll($event)"
          (click)="$event.stopPropagation()"
          [checked]="isAllSelected()"
          [indeterminate]="isIndeterminate()">
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let element">
        <mat-checkbox
          (change)="toggleSelection(element, $event)"
          (click)="$event.stopPropagation()"
          [checked]="isSelected(element)">
        </mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="sku">
      <th mat-header-cell *matHeaderCellDef> SKU </th>
      <td mat-cell *matCellDef="let element"> {{element.itemRefId}} </td>
    </ng-container>

    <ng-container matColumnDef="itemName">
      <th mat-header-cell *matHeaderCellDef> Item Name </th>
      <td mat-cell *matCellDef="let element"> {{element.itemName}} </td>
    </ng-container>

    <ng-container matColumnDef="qty">
      <th mat-header-cell *matHeaderCellDef> Qty </th>
      <td mat-cell *matCellDef="let element">
        <div class="quantity-controls">
          <button 
            class="quantity-btn decrement-btn"
            type="button"
            [disabled]="!getQuantityButtonsEnabled() || !canDecrement(element)"
            (click)="decrementQuantity(element); $event.stopPropagation()"
            [attr.aria-label]="'Decrease quantity'">
            -
          </button>
          <input 
            *ngIf="getQuantityButtonsEnabled()"
            class="quantity-input"
            type="text"
            [value]="getDisplayQuantity(element)"
            (input)="onQuantityInputChange(element, $event)"
            (blur)="onQuantityInputBlur(element, $event)"
            (keydown)="onQuantityKeyDown($event)"
            (click)="$event.stopPropagation()"
            [attr.min]="1"
            [attr.max]="getOriginalQuantity(element)"
            [attr.aria-label]="'Quantity'">
          <span *ngIf="!getQuantityButtonsEnabled()" class="quantity-value">{{getDisplayQuantity(element)}}</span>
          <button 
            class="quantity-btn increment-btn"
            type="button"
            [disabled]="!getQuantityButtonsEnabled() || !canIncrement(element)"
            (click)="incrementQuantity(element); $event.stopPropagation()"
            [attr.aria-label]="'Increase quantity'">
            +
          </button>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="dimensions">
      <th mat-header-cell *matHeaderCellDef> Dimensions (cm) </th>
      <td mat-cell *matCellDef="let element"> {{element.dimensions}} </td>
    </ng-container>

    <ng-container matColumnDef="netWeight">
      <th mat-header-cell *matHeaderCellDef> Net Weight (Kg) </th>
      <td mat-cell *matCellDef="let element"> {{element.weight | number: '1.2-2'}} </td>
    </ng-container>

    <ng-container matColumnDef="grossWeight">
      <th mat-header-cell *matHeaderCellDef> Gross Weight (Kg) </th>
      <td mat-cell *matCellDef="let element"> {{getGrossWeight(element) | number: '1.2-2'}} </td>
    </ng-container>

    <ng-container matColumnDef="cbm">
      <th mat-header-cell *matHeaderCellDef> CBM </th>
      <td mat-cell *matCellDef="let element"> {{getCBM(element) | number: '1.2-2'}} </td>
    </ng-container>

    <ng-container matColumnDef="dangerous">
      <th mat-header-cell *matHeaderCellDef> Dangerous </th>
      <td mat-cell *matCellDef="let element"> {{getDangerous(element)}} </td>
    </ng-container>

    <ng-container matColumnDef="temperature">
      <th mat-header-cell *matHeaderCellDef> Temperature </th>
      <td mat-cell *matCellDef="let element"> {{getTemperature(element)}} </td>
    </ng-container>

    <ng-container matColumnDef="fragile">
      <th mat-header-cell *matHeaderCellDef> Fragile </th>
      <td mat-cell *matCellDef="let element"> {{getFragile(element)}} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="visibleColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: visibleColumns;"></tr>
  </table>
</div>

